import { Avatar } from '@zep-us/zus/avatar';
import { Checkbox } from '@zep-us/zus/checkbox';
import { Chip } from '@zep-us/zus/chip';
import { type ClassGroupRes } from '@/api/gen/_model/classGroupRes';
import { cn } from '@/utils/tailwind.util';
import { getClassroomAvatarColor, getDefaultClassroomBackgroundRef, toClassroomBackgroundRef } from '../utils/classroomAvatarColor';

/** 피그마 ClassListItem: 아바타 · 이름/학생 수 · (연결됨) · 체크박스. 선택되면 보라 테두리. */
export function ClassListItem({
  classroom,
  isChecked,
  disabled,
  linkedLabel,
  memberCountLabel,
  onToggle
}: {
  classroom: ClassGroupRes;
  isChecked: boolean;
  disabled: boolean;
  linkedLabel: string;
  memberCountLabel: string;
  onToggle: () => void;
}) {
  // 클래스 목록·상세와 같은 색 규칙(저장 배경 → 클래스 id 기본값).
  const {
    avatarColor,
    avatarTextColor
  } = getClassroomAvatarColor(toClassroomBackgroundRef(classroom.background) ?? getDefaultClassroomBackgroundRef(classroom.classGroupId));
  return <li data-sentry-component="ClassListItem" data-sentry-source-file="ClassListItem.tsx">
      <label className={cn('flex min-h-[66px] cursor-pointer items-center gap-sm rounded-sm border bg-default px-md py-sm',
    // 선택 시 2px 선은 안쪽 ring 으로 더한다. border 를 2px 로 바꾸면 줄 크기가 1px씩 커져 흔들린다.
    isChecked ? 'border-strong ring-1 ring-inset ring-strong' :
    // 피그마 ClassListItem 호버: 흰 배경 그대로, 테두리 대신 shadow/sm.
    'border-opacity-assistive hover:border-transparent hover:shadow-sm', disabled && 'cursor-not-allowed')}>
        <Avatar size="md" rounded="full" aria-label={classroom.name}
      // 클래스 색을 틀에도 칠한다. 안 그러면 ZUS 틀의 연보라 배경이 1px 테두리 자리에 비친다.
      style={{
        backgroundColor: avatarColor
      }}
      // ZUS 틀의 1px 테두리·연보라 안쪽 바탕을 지워 원 가장자리의 옅은 선을 없앤다.
      className="border-0 [&>span]:bg-transparent" fallback={<span className="flex size-full items-center justify-center text-body-md-semibold" style={{
        backgroundColor: avatarColor,
        color: avatarTextColor
      }}>
              {classroom.name.slice(0, 2)}
            </span>} data-sentry-element="Avatar" data-sentry-source-file="ClassListItem.tsx" />
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="truncate text-body-lg-bold text-default">
            {classroom.name}
          </span>
          <span className="text-caption-lg-medium text-alternative">
            {memberCountLabel}
          </span>
        </span>
        {classroom.isLinked && <Chip size="sm" rounded="full" className="border-green-100 bg-green-50 text-caption-md-semibold text-positive">
            {linkedLabel}
          </Chip>}
        <Checkbox checked={isChecked} disabled={disabled} onCheckedChange={onToggle} data-sentry-element="Checkbox" data-sentry-source-file="ClassListItem.tsx" />
      </label>
    </li>;
}